import type { FieldValue } from "@/shared/types/workflow/workflow-form.types";
import type { SelectField } from "@spz/shared-domain";

/**
 * Returns the default value for a select field
 */
export function getSelectDefaultValue(field: SelectField): FieldValue {
  return field.multiple ? [] : "";
}
